import { css } from 'lit';
export const videoOverlayStyles = css `
    .video-overlay-wrapper {
        position: relative;
    }

    .overlay {
        position: absolute;
        inset: 0;
        background: linear-gradient(
            0deg,
            var(--hlx-overlay-background-color-weak-1) 0%,
            var(--hlx-overlay-background-color-weak-1) 100%
        );
        pointer-events: none;
    }

    .overlay-content {
        display: flex;
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
    }

    .video-content::slotted(:is(img, video)) {
        display: block;
        width: 100%;
    }

    .video-overlay-button {
        position: absolute;
        top: var(--hlx-spacing-lg);
        right: var(--hlx-spacing-lg);
        z-index: 2;
    }

    .video-overlay-button::part(base) {
        width: 42px;
        min-height: auto;
        height: 42px;
        background-color: var(--hlx-color-neutral-100);
        border-color: var(--hlx-color-neutral-100);
        opacity: 0.6;
        transition: opacity var(--hlx-motion-duration-default) var(--hlx-motion-easing-in-out);
    }

    .video-overlay-button::part(base):hover {
        opacity: 0.8;
    }

    .icon-wrapper {
        display: contents;
    }

    .extra-border {
        background: transparent;
        width: 40px;
        position: absolute;
        height: 40px;
        border-radius: 50%;
        border: 1px solid var(--hlx-color-gray-0);
    }

    .video-label {
        display: block;
        color: var(--hlx-text-color-weak-2);
        font-family: var(--hlx-text-font-family-serif);
        font-size: var(--hlx-text-font-size-sm);
        font-weight: var(--hlx-text-font-weight-normal);
        line-height: var(--hlx-text-line-height-default);
    }

    .video-label.has-video-label {
        margin-top: var(--hlx-spacing-md);
    }
`;
//# sourceMappingURL=video-overlay.styles.js.map